// This class contains all the logic for managing contact information

export default class Contact {
    constructor (object) {
        this._typeof = 'contact'

        if (object) {
            this._countryCode = object.countryCode
            this._email = object.email
            this._facebook = object.facebook
            this._instagram = object.instagram
            this._phone = object.phone
            this._telegram = object.telegram
            this._twitter = object.twitter
            this._whatsapp = object.whatsapp
        }
    }

    // getters
    get countryCode () {
        return this._countryCode
    }

    get email () {
        return this._email
    }

    get facebook () {
        return this._facebook
    }

    get instagram () {
        return this._instagram
    }

    get phone () {
        return this._countryCode + this._phone
    }

    get telegram () {
        return this._telegram
    }

    get twitter () {
        return this._twitter
    }

    get whatsapp () {
        return this._whatsapp
    }

    get typeof () {
        return this._typeof
    }

    // setters

    /**
     * @param {String} newCountryCode
     */
    set setCountryCode (newCountryCode) {
        this._countryCode = newCountryCode
    }

    /**
     * @param {String} newEmail
     */
    set setEmail (newEmail) {
        this._email = newEmail
    }

    /**
     * @param {String} newFacebook
     */
    set setFacebook (newFacebook) {
        this._facebook = newFacebook
    }

    /**
     * @param {String} newInstagram
     */
    set setInstagram (newInstagram) {
        this._instagram = newInstagram
    }

    /**
     * @param {String} newPhone
     */
    set setPhone (newPhone) {
        this._phone = newPhone
    }

    /**
     * @param {String} newTelegram
     */
    set setTelegram (newTelegram) {
        this._telegram = newTelegram
    }

    /**
     * @param {String} newTwitter
     */
    set setTwitter (newTwitter) {
        this._twitter = newTwitter
    }

    /**
     * @param {String} newWhatsapp
     */
    set setWhatsapp (newWhatsapp) {
        this._whatsapp = newWhatsapp
    }
}
